import { Spinner } from '@tigergraph/tiger-ui';
import clsx from 'clsx';

export const StyledContainer = (props: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div
      {...props}
      className={clsx(
        props.className,
        'absolute top-0 left-0 bottom-0 right-0 bg-[linear-gradient(180deg,#E8842C_0%,#FFFAF6_100%)]'
      )}
    >
      {props.children}
    </div>
  );
};

export const StyledLoadingContainer = (props: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div {...props} className={clsx(props.className, 'w-full h-auto flex mt-[10px] justify-center')}>
      {props.children}
    </div>
  );
};

export const StyledFormContainer = (props: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div
      {...props}
      className={clsx(
        props.className,
        'h-auto w-[480px] bg-white rounded-[10px] absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pt-[56px] pl-[60px] pr-[60px] pb-[56px] box-border max-[720px]:w-[90%] max-[720px]:left-[5%] max-[720px]:ml-0 max-[720px]:mt-0 max-[720px]:top-[5%] max-[720px]:translate-0'
      )}
    >
      {props.children}
    </div>
  );
};

export const CenterContainer = (props: React.HTMLProps<HTMLDivElement>) => {
  return (
    <div {...props} className={clsx(props.className, 'flex justify-center flex-col w-full')}>
      {props.children}
    </div>
  );
};

export const ExtraLargeSpinner = () => {
  return <Spinner className="text-[var(--background)]" />;
};
